class CampaignSwiper {
  constructor(el,opt){
    this.el = el;
    this.event();
  }
  event(){
    var campaignSwiper;

    function initSwiper() {
      campaignSwiper = new Swiper('.campaign-swiper', {
        slidesPerView: 1.2,
        spaceBetween: 8,
        loopAdditionalSlides: 1,
        speed: 1000,
        loop: true,
        allowTouchMove: false,
        navigation: {
          nextEl: ".js-campaign-next",
          prevEl: ".js-campaign-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          type: "bullets",
          clickable: true,
        },
        breakpoints: {
          // 767px以上の場合
          767: {
            slidesPerView: 4,
            spaceBetween: 20,
          }
        }
      });
    }
    
    // ナビゲーションボタンの表示を制御する関数
    function toggleNavigationButtons() {
      const slides = document.querySelectorAll('.campaign-swiper .swiper-slide');
      const nextButton = document.querySelector('.js-campaign-next');
      const prevButton = document.querySelector('.js-campaign-prev');

      console.log(slides.length);
    
      if (slides.length <= 4) {
        nextButton.style.display = 'none';
        prevButton.style.display = 'none';
      } else {
        nextButton.style.display = '';
        prevButton.style.display = '';
      }
    }
    
    // ウィンドウのリサイズ時にSwiperを初期化または破棄
    function handleResize() {
      if (window.innerWidth > 767) {
        toggleNavigationButtons(); // ナビゲーションボタンの表示を切り替える
        if (!campaignSwiper) {
          initSwiper(); // Swiperを初期化
        }
      } else {
        if (campaignSwiper) {
          campaignSwiper.destroy(true, true); // Swiperを破棄
          campaignSwiper = null; // インスタンスをリセット
        }
      }
    
    }
    
    // 初期化
    handleResize();
    window.addEventListener('resize', handleResize);
    
  }
}
